export const ArenaNavigationDefaultType = {
	LEAGUES_TEAMS: 'leagues_teams',
	CLUBS_TEAMS:   'clubs_teams',
	SPORTS:        'sports',
	CLUBS:         'clubs',
	TEAMS:         'teams',
};
